export default "__VITE_ASSET__N4GIcpsm__"